import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import styled, {css} from 'styled-components';

export function Layout({children}) {
  return (
    <>
      <a href="/" className="mob_logo w-inline-block"><img src="https://uploads-ssl.webflow.com/6111881d93d2ef32c6c8be3a/611c2af5ef99da069a3cdb0f_crg_logo.svg" loading="lazy" alt='logo' className="mob_logo_img" /></a>
      {children}
    </>
  )
}